export default class ResetButton {
  constructor(handler) {
    this.handler = handler;
  }

  onAdd(map) {
    this.map = map;

    const span = document.createElement('span');
    span.className = 'mapboxgl-ctrl-icon';
    span.title = 'Reset mas state to default';

    const button = document.createElement('button');
    button.className = 'mapboxgl-ctrl-reset';
    button.appendChild(span);
    button.addEventListener('click', this.handler);

    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    this.container.appendChild(button);

    return this.container;
  }

  onRemove() {
    this.container.removeEventListener('click', this.handler);
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}
